import React, { useState, useEffect } from "react";
import Color from "./styles/Color";
import { withRouter } from "react-router-dom";
import Nav from "./components/navbar/Nav";
import MainContainer from "./MainContainer";
import Login from "./pages/authentication/Login";
import { connect } from "react-redux";
import { addUser } from "./redux/actions/user";
import AbsoluteLoaderContainer from "./components/Loaders/AbsoluteLoaderContainer";
import { ThemeProvider, createUseStyles } from "react-jss";
import ColorCollection from "./utils/color-collection";
import siteConfiguration from "./utils/site-config";
import { getCurrentSite, getUserInfo, getFirstSamvId } from "./utils/helpers";
import { compose } from "redux";
import { GetData } from "./utils/axios";
import { useIdleTimer } from "react-idle-timer";
import { AccountType } from "./utils/Enums";
import _ from "lodash";
import TooltipPopup from "./components/Tooltip/TooltipPopup";

var tags = [
  // '<link rel="apple-touch-icon" sizes="57x57" href="/content/customer/-1/apple-touch-icon-57x57.png">',
  // '<link rel="apple-touch-icon" sizes="60x60" href="/content/customer/-1/apple-touch-icon-60x60.png">',
  // '<link rel="apple-touch-icon" sizes="72x72" href="/content/customer/-1/apple-touch-icon-72x72.png">',
  // '<link rel="apple-touch-icon" sizes="76x76" href="/content/customer/-1/apple-touch-icon-76x76.png">',
  // '<link rel="apple-touch-icon" sizes="114x114" href="/content/customer/-1/apple-touch-icon-114x114.png">',
  // '<link rel="apple-touch-icon" sizes="120x120" href="/content/customer/-1/apple-touch-icon-120x120.png">',
  // '<link rel="apple-touch-icon" sizes="144x144" href="/content/customer/-1/apple-touch-icon-144x144.png">',
  // '<link rel="apple-touch-icon" sizes="152x152" href="/content/customer/-1/apple-touch-icon-152x152.png">',
  // '<link rel="apple-touch-icon" sizes="180x180" href="/content/customer/-1/apple-touch-icon-180x180.png">',
  // '<link rel="icon" type="image/png" href="/content/customer/-1/favicon-32x32.png" sizes="32x32">',
  '<link rel="icon" type="image/png" href="/content/customer/-1/android-chrome-192x192.png" sizes="192x192">',
  // '<link rel="icon" type="image/png" href="/content/customer/-1/favicon-96x96.png" sizes="96x96">',
  // '<link rel="icon" type="image/png" href="/content/customer/-1/favicon-16x16.png" sizes="16x16">',
  // '<link rel="shortcut icon" href="/content/customer/-1/favicon.ico">',
  '<meta name="msapplication-TileImage" content="/content/customer/-1/mstile-144x144.png">',
  '<meta name="msapplication-config" content="/content/customer/-1/browserconfig.xml">',
];

const App = (props) => {
  const { history, location, userState, addUser } = props;
  useStyles();
  const [visibles, setVisibles] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  const [isLoading, setIsLoading] = useState(true);
  const [forbundCode, setForbundCode] = useState(0);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [shouldRefreshCookie, setShouldRefreshCookie] = useState(true);

  useEffect(() => {
    const currentSite = getCurrentSite(window.location.hostname);
    setForbundCode(siteConfiguration[currentSite].colorThemeCode);
    document.title = siteConfiguration[currentSite].title;

    isAuth().then((isAuthed) => {
      if (isAuthed) {
        reLoginIfPageIsRefreshed();
      } else {
        setIsLoading(false);
      }
    });

    const head = document.getElementsByTagName("head")[0];
    tags.map((tag) => {
      const t = tag.replace(
        "/-1/",
        "/" + siteConfiguration[currentSite].colorThemeCode + "/"
      );
      return head.insertAdjacentHTML("beforeend", t);
    });
  }, []);

  useEffect(() => {
    //Refresh cookie every 5 minutes
    let cookieRefresher = setInterval(async () => {
      if (shouldRefreshCookie && userState?.user) {
        if (userState.user?.id || !location.pathname.includes("/logout")) {
          await refresh();
        }
      }
    }, 1000 * 60 * 5);
    return () => clearInterval(cookieRefresher);
  }, [userState.user, shouldRefreshCookie]);

  useEffect(() => {
    if (userState && userState?.user?.id) {
      setIsLoggedIn(true);
      if (isLoading) {
        setIsLoading(false);
      }
    } else {
      setIsLoggedIn(false);
    }
  }, [userState.user]);

  const reLoginIfPageIsRefreshed = async () => {
    const userData = await GetData("/user");
    if (userData) {
      //Kolla om användaren har tidigare valt samvpartsytan, kolla i localstorage och hämta smvp på nytt
      const storedSelectedSmvp = JSON.parse(
        localStorage.getItem("selectedSmvp")
      );

      if (storedSelectedSmvp && storedSelectedSmvp.userID === userData.id) {
        const smvpData = await GetData(
          "/samverkanspart/" + storedSelectedSmvp?.samvId + "?fullObject=true"
        );
        handleLogin(userData, smvpData);
      } else {
        if (storedSelectedSmvp) {
          localStorage.setItem("selectedSmvp", null);
        }
        if (userData.onlySamverkansparts) {
          let samvId = getFirstSamvId(userData);
          const smvpData = await GetData(
            "/samverkanspart/" + samvId + "?fullObject=true"
          );
          let saveData = {
            userID: userData.id,
            samvId: samvId,
          };
          localStorage.setItem("selectedSmvp", JSON.stringify(saveData));
          handleLogin(userData, smvpData);
        } else {
          handleLogin(userData);
        }
      }
    }
  };

  const handleLogin = (user, smvp) => {
    let userInfo = getUserInfo(user, smvp);

    addUser(userInfo);
    // location && location.pathname && location.pathname.includes("/logout");
    if (_.get(location, "pathname", "").includes("/logout")) {
      let previousUrl = new URLSearchParams(location.search).get("from");
      if (previousUrl && !previousUrl.toString().includes("logout/expired")) {
        history.replace(previousUrl);
      } else {
        if (userInfo.accountType === AccountType.Samverkanspart) {
          history.replace("/samverkansparts");
        } else {
          history.replace("/");
        }
      }
    }
    if (userInfo.accountType === AccountType.Samverkanspart) {
      history.replace("/samverkansparts");
    }
  };

  const refresh = async () => {
    try {
      await GetData("/auth/refresh");
    } catch (error) {
      console.log("refresh-error", error);
      return false;
    }
  };

  const isAuth = async () => {
    return await GetData("/auth");
  };

  const toggleSubmenu = (e) => {
    const val = Number(e ? e.currentTarget.value : "-1");
    const newVisibles = [...visibles];
    const closeNode = val > 0 ? newVisibles[val] : false;
    for (let i = 0; i < newVisibles.length; i++) {
      newVisibles[i] = false;
    }
    if (val >= 0 && !closeNode) newVisibles[val] = true;
    setVisibles(newVisibles);
  };

  const handleOnIdle = () => {
    if (shouldRefreshCookie) {
      setShouldRefreshCookie(false);
    }
  };

  const handleOnActive = () => {
    if (!shouldRefreshCookie) {
      setShouldRefreshCookie(true);
    }
  };

  //Set user to idle after 15 minutes
  useIdleTimer({
    timeout: 1000 * 60 * 15,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    debounce: 500,
  });

  return (
    <ThemeProvider theme={ColorCollection[forbundCode]}>
      {isLoading ? (
        <AbsoluteLoaderContainer totalCenter title="Startar applikation" />
      ) : isLoggedIn ? (
        <React.Fragment>
          <Nav
            toggleSubmenu={toggleSubmenu}
            visibles={visibles}
            logout={() => history.replace("/logout")}
          />
          <MainContainer toggleSubmenu={toggleSubmenu} />
        </React.Fragment>
      ) : (
        <Login
          code={forbundCode}
          location={props.location}
          handleLogin={reLoginIfPageIsRefreshed} //handleLogin={handleLogin }
        />
      )}
      <TooltipPopup />
    </ThemeProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    userState: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addUser: (user) => dispatch(addUser(user)),
  };
};

App.displayName = "App";

const useStyles = createUseStyles({
  "@global": {
    body: {
      fontFamily: "Roboto",
      fontSize: "13px",
      backgroundColor: "rgb(243, 245, 247)",
      color: "#353c43",
      margin: 0,
      padding: 0,
      letterSpacing: "0.5px",
      "& div": {
        boxSizing: "border-box",
      },
      "& abbr[title],& acronym[title]": {
        borderBottom: "none",
        textDecoration: "none",
      },
      "& a": {
        textDecoration: "none",
        color: "#335cda",
      },
      "& h1,& h2, & h3,& h4,& h5, & h6,& p, & ul": {
        margin: 0,
        padding: 0,
        fontWeight: "400",
        letterSpacing: "0.5px",
      },
      "& h1": {
        fontSize: "30px",
        letterSpacing: "0.8px",
        fontWeight: "normal",
      },
      "& h3": {
        fontWeight: 500,
      },
      "& input, & textarea, & select": {
        fontSize: "14px",
        fontFamily: "Roboto",
        display: "block",
        color: "#565867",
        height: "auto",
        lineHeight: "1.14",
        letterSpacing: "0.5px",
        width: "100%",
        padding: "11px 12px",
        boxSizing: "border-box",
      },
      "& input[type=checkbox], & input[type=radio]": {
        display: "inline",
        height: "auto",
        lineHeight: 0,
        letterSpacing: 0,
        width: "auto",
        padding: 0,
      },
      "& p": {
        color: "#565867",
        lineHeight: "1.5",
      },
      "& input[type=text],& textarea,& input[type=password],& input[type=tel],& input[type=email],& input[type=time]":
        {
          backgroundColor: "transparent",
          border: "1px solid #cbd2dc",
          borderRadius: "4px",
          "&:disabled": {
            color: Color.disabledTextColor() + "!important",
            border: "1px solid",
            borderColor: Color.disabledBorderColor(),
            backgroundColor: Color.disabledInputColor() + "!important",
            opacity: 1,
            WebkitTextFillColor: Color.disabledTextColor() + "!important",
          },
        },
      "& select": {
        "&:disabled": {
          color: Color.disabledTextColor() + "!important",
          backgroundColor: Color.disabledInputColor() + "!important",
          opacity: 1,
          WebkitTextFillColor: Color.disabledTextColor() + "!important",
        },
      },
      "& textarea": {
        backgroundColor: "white",
        resize: "none",
      },
      "& .form-group": {
        marginBottom: "32px",
      },
      "& .showOnMobile": {
        display: "none!important",
      },
      "& .hideOnMobile": {
        display: "block!important",
      },
      "& .text-center": {
        textAlign: "center",
      },
      "& .clearfix:after": {
        content: "",
        clear: "both",
        display: "table",
      },
    },
    "#style-1::-webkit-scrollbar-track": {
      WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.3))",
      borderRadius: "10px",
      backgroundColor: "#F5F5F5",
    },
    "#style-1::-webkit-scrollbar": {
      width: "8px",
      borderRadius: "15px",
      backgroundColor: "#F5F5F5",
    },
    "#style-1::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,.3)",
      backgroundColor: "#c7cdd2",
    },
    label: {
      display: "block",
      fontWeight: 500,
      fontSize: "14px",
      marginBottom: "8px",
      "&::first-letter": {
        textTransform: "uppercase",
      },
      "& div:first-child": {
        "&::first-letter": {
          textTransform: "uppercase",
        },
      },
    },
    h1: {
      textTransform: "lowercase",
      "&::first-letter": {
        textTransform: "uppercase",
      },
    },
    button: {
      cursor: "pointer",
      textAlign: "center",
      lineHeight: 1.5,
      fontWeight: 500,
      fontFamily: "Roboto",
      "& svg": {
        display: "block",
      },
      "&:disabled": {
        backgroundColor: "rgb(202,209,218)",
        borderColor: Color.disabledTextColor(),
        color: Color.disabledTextColor(),
        "&:hover": {
          backgroundColor: "rgb(202,209,218)",
          borderColor: Color.disabledTextColor(),
          color: Color.disabledTextColor(),
        },
      },
    },
    "@media (max-width: 1023px)": {
      "@global": {
        body: {
          "& h1": {
            fontSize: "20px",
          },
          "& input[type=time]": {
            height: "2.375rem",
          },
          "& .logo": {
            display: "none",
          },
          "& .showOnMobile": {
            display: "block!important",
          },
          "& .hideOnMobile": {
            display: "none!important",
          },
        },
      },
    },
  },
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(App);
